import React, { useState, useEffect } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError, confirmDelete } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash } from 'react-icons/fa';

const FeesPage = () => {
  const [chapter, setChapter] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    chapters: [],
    fees: '',
    setAllChapters: false,
  });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [chapterOptions, setChapterOptions] = useState([]);
  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10);  
  // const limit = 3;
  // Fetch chapters for dropdown
  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const res = await axios.get('/admin/api/chapters/all');
        setChapterOptions(res.data?.chapter?.map(c => ({ value: c._id, label: c.name })) || []);
      } catch (err) {
        // ignore
      }
    };
    fetchChapters();
  }, []);

  useEffect(() => {
    fetchChapter(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const fetchChapter = async (page = 1, search = '') => {
    try {
      const res = await axios.get(`/admin/api/chapters/all?page=${page}&limit=${limit}&search=${search}`);
      const { chapter = [], totalCount = 0 } = res.data;
      setChapter(chapter);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch Chapter:', err);
    }
  };

  const handleSave = async () => {
    const validationRules = editingId 
      ? { fees: { required: true } }
      : { fees: { required: true } };
    
    const validationErrors = validateForm(formValues, validationRules);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    console.log('Form values:', formValues);
    console.log('Chapter options:', chapterOptions);

    try {
      if (editingId) {
        // Update single chapter fees
        const updateData = {
            chapters: [{
              _id: editingId,
              fees: parseFloat(formValues.fees)
            }]
        };

        console.log('Updating single chapter:', editingId, 'with fees:', updateData);
        // await axios.put(`/admin/api/chapters/${editingId}`, { fees: formValues.fees });
        await axios.put(`/admin/api/chapters/bulk-update`, updateData);
        toastSuccess('Chapter fees updated successfully!');
      } else {
        // Check if user wants to set all chapters or selected chapters
        if (formValues.setAllChapters) {
          // Set fees for all chapters
          if (!chapterOptions || chapterOptions.length === 0) {
            toastError('No chapters available to update');
            return;
          }
          const updateData = {
            chapters: chapterOptions.map(option => ({
              _id: option.value,
              fees: parseFloat(formValues.fees)
            }))
          };
          console.log('Setting fees for all chapters:', updateData);
          const response = await axios.put('/admin/api/chapters/bulk-update', updateData);
          console.log('Set all fees response:', response.data);
          toastSuccess('All chapter fees updated successfully!');
        } else {
          // Set fees for selected chapters
          if (!formValues.chapters || formValues.chapters.length === 0) {
            toastError('Please select chapters or choose "Set All Chapters" option');
            return;
          }
          const updateData = {
            chapters: formValues.chapters.map(chapterId => ({
              _id: chapterId,
              fees: parseFloat(formValues.fees)
            }))
          };
          console.log('Bulk updating selected chapters:', updateData);
          // console.log('Selected chapters data:', formValues.chapters);
          const response = await axios.put('/admin/api/chapters/bulk-update', updateData);
          // console.log('Bulk update response:', response.data);
          toastSuccess('Chapter fees set successfully!');
        }
      }
      setCurrentPage(1);
      fetchChapter(1, searchQuery);
      handleCancel();
    } catch (err) {
      console.error('Failed to save chapter fees:', err);
      console.error('Error details:', err.response?.data);
      toastError(err.response?.data?.message || 'Failed to save chapter fees');
    }
  };

  const handleEdit = (chapterData) => {
    setEditingId(chapterData._id);
    setFormValues({
      chapters: [{ value: chapterData._id, label: chapterData.name }],
      fees: chapterData.fees || '',
      setAllChapters: false,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const confirmed = await confirmDelete('Are you sure you want to delete this chapter fees?');
    if (confirmed) {
      try {
        await axios.delete(`/admin/api/chapters/${id}/fees`);
        toastSuccess('Chapter fees deleted successfully!');
        fetchChapter(currentPage, searchQuery);
      } catch (err) {
        console.error('Failed to delete chapter fees:', err);
        toastError('Failed to delete chapter fees');
      }
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({ chapters: [], fees: '', setAllChapters: false });
    setEditingId(null);
    setErrors({});
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0"> Chapter Fees</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search Chapter..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">Chapter List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Set Chapter Fees
          </button>
        </div>
       <div className="table-responsive">
        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2">Chapter Name</th>
                <th className="py-1 px-2">Fees</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {chapter.length > 0 ? (
                chapter.map((chapter, idx) => {
                  return (
                    <tr key={chapter._id}>
                      <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                      <td className="py-1 px-2">{chapter.name}</td>
                      <td className="py-1 px-2">₹{chapter.fees || '0'}</td>
                      <td className="py-1 px-2">
                        <button
                          className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-primary-custom"
                          onClick={() => handleEdit(chapter)}
                        >
                          <FaEdit />
                        </button>
                        <button className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-danger"
                          onClick={() => handleDelete(chapter._id)}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-2">No Chapter found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className="{`btn btn-sm page-btn ${currentPage === page ? 'active' : ''}`}"
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
      <CommonModalForm
        visible={showModal}
        title={editingId ? "Edit Chapter Fees" : "Set Chapter Fees"}
        fields={[
          ...(editingId ? [] : [
            { 
              name: 'setAllChapters', 
              label: 'Set All Chapters', 
              type: 'checkbox', 
              placeholder: 'Check to set fees for all chapters in the system' 
            },
            ...(formValues.setAllChapters ? [] : [{ 
              name: 'chapters', 
              label: 'Select Chapters', 
              type: 'select', 
              isMulti: true, 
              options: chapterOptions, 
              placeholder: 'Select multiple chapters' 
            }])
          ]),
          { 
            name: 'fees', 
            label: 'Fees Amount', 
            type: 'number', 
            placeholder: 'Enter fees amount' 
          },
        ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={editingId ? "Update Fees" : "Set Fees"}
        requiredFields={['fees']}
      />
    </div>
  );
};

export default FeesPage;
